<template>
  <el-aside width="250px" style="background-color: rgb(238, 241, 246)">
    <el-menu :unique-opened="true" :default-active="menuActive" @select="selectMenu">
      <span v-for="(m,mIndex) in menuData" :key="m.routeName">
        <el-submenu :index="mIndex + ''" v-if="m.twoMenu" >
          <template slot="title">
            <i v-if="typeof m.iconfont !== 'undefined' " class="iconfont" :class="m.iconfont"></i>
            {{m.name}}
          </template>
          <span v-for="(sec,secIndex) in m.twoMenu" :key="sec.routeName">
            <el-submenu :index="`${mIndex}-${secIndex}`" v-if="sec.thrMenu">
              <template slot="title">
                <i
                  v-if="typeof sec.iconfont !== 'undefined' "
                  class="iconfont"
                  :class="sec.iconfont"
                ></i>
                {{sec.name}}
              </template>
              <el-menu-item
                :index="`${mIndex}-${secIndex}-${thrIndex}`"
                v-for="(thr,thrIndex) in sec.thrMenu"
                :key="thr.routeName"
              >
                <i
                  v-if="typeof thr.iconfont !== 'undefined' "
                  class="iconfont"
                  :class="thr.iconfont"
                ></i>
                {{thr.name}}
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else :index="`${mIndex}-${secIndex}`">
              <i
                v-if="typeof sec.iconfont !== 'undefined' "
                class="iconfont"
                :class="sec.iconfont"
              ></i>
              <span slot="title">{{sec.name}}</span>
            </el-menu-item>
          </span>
        </el-submenu>
        <el-menu-item v-else :index="mIndex + ''">
          <i v-if="typeof m.iconfont !== 'undefined' " class="iconfont" :class="m.iconfont"></i>
          <span slot="title">{{m.name}}</span>
        </el-menu-item>
      </span>
    </el-menu>
  </el-aside>
</template>

<script>
import FhMenu from "@/fhMenu"
import devConfig from "@/devConfig";
export default {
  data() {
    return {
      menuData: {},
      menuActive:'0'
    };
  },
  created() {
    const path =  cookie.getItem('path') || '0'
    devConfig.init(this, () => {
        this.menuData = FhMenu.getMenu()
        this.menuActive = path
    })
  },
  watch: {
        '$route' (to, from) {
            let path = ''
            if(typeof to.query.oneIndex !== 'undefined') path += to.query.oneIndex
            if(typeof to.query.twoIndex !== 'undefined') path += `-${to.query.twoIndex}`
            if(typeof to.query.thrMenuIndex !== 'undefined') path += `-${to.query.thrMenuIndex}`
            
            if(to.name === 'home')   path = '0'

            if(path !== '')
            {
                this.menuActive = path
                cookie.setItem('path', this.menuActive)
                this.$emit('selectMenu', path)
            }
            
        }
    },
    methods: {
        selectMenu(index){
            this.menuActive = index
            cookie.setItem('path', this.menuActive)
            this.$emit('selectMenu', index)
        }
    }
};
</script>

<style scoped>
.iconfont{
    margin-right: 8px;
}
</style>